import type { UnresolvedSubmissionStore } from '@core/ports/UnresolvedSubmissionStore';

export class UnresolvedSubmissionUseCase {
  public constructor(private readonly store: UnresolvedSubmissionStore) {}

  public hasUnknownOutcome(): boolean {
    return this.store.hasUnknownSubmissionOutcome();
  }

  public markUnknownOutcome(): void {
    this.store.markUnknownSubmissionOutcome();
  }

  public clearUnknownOutcome(): void {
    this.store.clearUnknownSubmissionOutcome();
  }
}
